//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Pagination",
  props: ["page", "perPage", "pageCount", "totalCount", "loading"],
  computed: {
    pagination: function () {
      var page = this.page;
      var siblingCount = 1;
      var boundaryCount = 1;
      var count = this.pageCount;
      var range = function range(start, end) {
        var length = end - start + 1;
        return Array.from(
          {
            length: length,
          },
          function (_, i) {
            return start + i;
          }
        );
      };

      var startPages = range(1, Math.min(boundaryCount, count));
      var endPages = range(
        Math.max(count - boundaryCount + 1, boundaryCount + 1),
        count
      );
      var siblingsStart = Math.max(
        Math.min(
          page - siblingCount,
          count - boundaryCount - siblingCount * 2 - 1
        ),
        boundaryCount + 2
      );
      var siblingsEnd = Math.min(
        Math.max(page + siblingCount, boundaryCount + siblingCount * 2 + 2),
        endPages[0] - 2
      );

      let items = [].concat(
        startPages,
        siblingsStart > boundaryCount + 2
          ? ["start-ellipsis"]
          : boundaryCount + 1 < count - boundaryCount
            ? [boundaryCount + 1]
            : [],
        range(siblingsStart, siblingsEnd),
        siblingsEnd < count - boundaryCount - 1
          ? ["end-ellipsis"]
          : count - boundaryCount > boundaryCount
            ? [count - boundaryCount]
            : [],
        endPages
      );

      return items.map((item) => {
        if (typeof item === "number") {
          return {title: item, page: item};
        }

        return {title: "...", disabled: true};
      });
    },

    shows: function () {
      const shows = this.page * this.perPage - (this.perPage - 1);

      if (this.totalCount < shows) {
        return this.totalCount;
      }

      return this.page * this.perPage - (this.perPage - 1);
    },
    total: function () {
      return this.totalCount;
    },
  },
  methods: {
    getHref(pageNumber) {
      let host = 'https://';

      host += process.server ? this.$nuxt.context.req.headers.host : window.location.host;

      host += this.$route.fullPath.includes('page=')
        ? this.$route.fullPath.replace(/page=\d+/, `page=${pageNumber}`)
        : this.$route.fullPath + `${Boolean((this.$route.fullPath || '').includes('?')) ? "&" : "?"}` + `page=${pageNumber}`;

      return host;
    },
    onLoadMore: function () {
      this.$emit("onLoadMore");
    },
    onChangePage: function (page) {
      this.$emit("onChangePage", page);
      window.scrollTo(0, 0);
    },
  },
};
